import React, { Component, PropTypes } from 'react';
import { init, destroy } from './../casino/providergames.js';

class Provider extends Component {
	componentWillMount() {
		init(this.props.match.params.providerName);
	}

	componentWillUnmount() {
		destroy();
	}

	render() {
		return (
			<div id="provider" />
		);
	}
}

Provider.propTypes = {
	params: PropTypes.object
};

export default Provider;



// WEBPACK FOOTER //
// ./mobile-core/src/components/provider.js